import axios from "axios";
import authHeader from "@/services/auth-header";
import ConstApiUrls from "@/services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL;

class FtRegistrationFileService {
  getApiUrl() {
    return API_URL;
  }
  getAllFtRegistrationFile() {
    return axios.get(API_URL + `getAllFtRegistrationFile`, {
      headers: authHeader(),
    });
  }
  getAllFtRegistrationFileContaining(page, pageSize, sortBy, order, search) {
    // return axios.get(API_URL + `getAllFtRegistrationFile`, { headers: authHeaderMultipart() });
    return axios.get(
      API_URL +
        `getAllFtRegistrationFileContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`,
      { headers: authHeader() }
    );
  }
  getFtRegistrationFileById(id) {
    return axios.get(API_URL + `getFtRegistrationFileById/${id}`, {
      headers: authHeader(),
    });
  }

  getAllFtRegistrationFileByParent(id) {
    return axios.get(API_URL + `getAllFtRegistrationFileByParent/${id}`, {
      headers: authHeader(),
    });
  }
  getAllFtRegistrationFileByParentIds(ids) {
    return axios.post(API_URL + `getAllFtRegistrationFileByParentIds`, ids,{
      headers: authHeader(),
    });
  }

  getAllFtRegistrationFileByParentPublic(id) {
    return axios.get(API_URL + `public/getAllFtRegistrationFileByParent/${id}`, {
      headers: authHeader(),
    });
  }


  getAllFtRegistrationFileByFtRegistrationBean(ftRegistrationBean) {
    return axios.get(API_URL + `getAllFtRegistrationFileByFtRegistrationBean/${ftRegistrationBean}`, {
      headers: authHeader(),
    });
  }
  getAllFtRegistrationFileByFtRegistrationBeanAndFileType(ftRegistrationBean, fileType) {
    return axios.get(API_URL + `getAllFtRegistrationFileByFtRegistrationBeanAndFileType/${ftRegistrationBean}/${fileType}`, {
      headers: authHeader(),
    });
  }
  getAllFtRegistrationFileByFtRegistrationBeanAndFileTypeAndFtemplateRegDokumenBean(ftRegistrationBean, fileType, ftemplateRegDokumenBean) {
    return axios.get(API_URL + `getAllFtRegistrationFileByFtRegistrationBeanAndFileTypeAndFtemplateRegDokumenBean/${ftRegistrationBean}/${fileType}/${ftemplateRegDokumenBean}`, {
      headers: authHeader(),
    });
  }


  updateFtRegistrationFile(item) {
    return axios.put(API_URL + `updateFtRegistrationFile/${item.id}`, item, {
      headers: authHeader(),
    });
  }
  createFtRegistrationFile(item) {
    return axios.post(API_URL + `createFtRegistrationFile`, item, {
      headers: authHeader(),
    });
  }
  deleteFtRegistrationFile(id) {
    return axios.delete(API_URL + `deleteFtRegistrationFile/${id}`, {
      headers: authHeader(),
    });
  }

  deleteFtRegistrationFileAvatarByParent(fkegiatanBean) {
    return axios.delete(
      API_URL + `deleteFtRegistrationFileAvatarByParent/${fkegiatanBean}`,
      {
        headers: authHeader(),
      }
    );
  }
  createFtRegistrationFileAvatar(item) {
    return axios.post(API_URL + `createFtRegistrationFileAvatar`, item, {
      headers: authHeader(),
    });
  }

  deleteAllFtRegistrationFile(itemIds) {
    return axios.delete(API_URL + `deleteAllFtRegistrationFile`, {
      headers: authHeader(),
      data: itemIds,
    });
  }
  deleteFtRegistrationFileMulti(items) {
    return axios.delete(API_URL + `deleteFtRegistrationFileMulti`, {
      headers: authHeader(),
      data: items,
    });
  }

  deleteFtRegistrationFileTextByParent(ftRegistrationBean) {
    return axios.delete(API_URL + `deleteFtRegistrationFileTextByParent/${ftRegistrationBean}`, {
      headers: authHeader()
    });
  }

  createFtRegistrationFileMulti(payloadMulti) {

    return axios.post(API_URL + `createFtRegistrationFileMulti`, payloadMulti, {
      headers: authHeader(),
    });
  }

  createAndDeleteFtRegistrationFileMulti(ftRegistrationBean, payloadMulti) {

    return axios.post(API_URL + `createAndDeleteFtRegistrationFileMulti/${ftRegistrationBean}`, payloadMulti, {
      headers: authHeader(),
    });
  }


}
export default new FtRegistrationFileService();
